import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { SessionVisualizer } from 'components/common/sessions/dialogs/visualize-session/visualizer';
import { t } from 'i18next';
import { IBaseDialog } from 'interfaces/i-dialogs';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ISessionSummary } from 'lib_ts/interfaces/i-session-summary';

interface IProps extends IBaseDialog {
  session: Partial<ISessionSummary>;
}

// ! deprecate this since we can just use LR
export const VisualizeSessionDialog = (props: IProps) => {
  return (
    <ErrorBoundary identifier="VisualizeSessionDialog">
      <CommonDialog
        identifier={props.identifier}
        title={`${t('common.session')} ${props.session}`}
        content={<SessionVisualizer session={props.session} />}
        width={RADIX.DIALOG.WIDTH.XL}
        onClose={props.onClose}
      />
    </ErrorBoundary>
  );
};
